import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingFarmRefrigerantUsage, setFootprintingFarmRefrigerantUsageAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_FARM, FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN, FOOTPRINTING_FARM_REFRIGERANT_USAGE } from "consts";

import { FootprintingFarmRefrigerantPayload } from "models";

export const useMutateFootprintingFarmRefrigerantUsage = (
  farmId: string,
  year: number,
  payload: FootprintingFarmRefrigerantPayload,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? setFootprintingFarmRefrigerantUsageAdmin : setFootprintingFarmRefrigerantUsage;
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_REFRIGERANT_USAGE],
      mutationFn: () => queryFn(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_FARM_REFRIGERANT_USAGE, primaryDataId],
          [FOOTPRINTING_FARM, farmId, year],
          [FOOTPRINTING_FARM_PRIMARY_DATA_ADMIN, primaryDataId],
          [FOOTPRINTING_FARM, primaryDataId, isAdmin],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
